export default "__VITE_ASSET__DjEaX6ww__"